import { createLocalization, type Localization } from "@florisoft/framework"
import { florisoftUiResources } from "./resources"

let defaultLocalization: Localization | undefined

export function getDefaultUiLocalization(): Localization {
  return (defaultLocalization ??= createLocalization({
    culture: "en-GB",
    uiCulture: "en-GB",
    timeZone: "UTC",
    resources: [florisoftUiResources],
  }))
}
